/**
 * The server's reason codes, said plainly. One dictionary for every screen
 * that names why a cycle or a slot is held, so Обзор and Система never
 * describe one fault in two ways. An unknown code shows as written: hiding it
 * would leave the fault without a name.
 */
const REASON: Readonly<Record<string, string>> = {
  RECONCILIATION_PENDING: "ждёт первой сверки",
  RECONCILIATION_FAILED: "сверка не удалась",
  VENUE_ORDER_UNLINKED: "ордер не связан с биржевым",
  ORDER_EXECUTION_QUANTITY_MISMATCH: "объём исполнений не сходится",
  EXECUTION_CONFLICT: "исполнения противоречат друг другу",
  EXECUTION_HISTORY_GAP: "в истории исполнений разрыв",
  ORDER_SUBMISSION_UNKNOWN: "судьба заявки неизвестна",
  TRAILING_EVIDENCE_GAP: "нет записи трейлинга",
  EVIDENCE_COMMIT_UNVERIFIED: "запись не подтверждена",
  EVIDENCE_STORE_UNAVAILABLE: "хранилище записей недоступно",
  EVIDENCE_INCOMPLETE: "запись цикла неполная",
  VENUE_ORDER_LIVENESS_GAP: "состояние ордеров на бирже не подтверждено",
  LEGACY_CYCLE: "цикл старого контракта",
  ENTRY_OUT_OF_TIME: "вход не успел в отведённое время",
  GLOBAL_NEW_ADMISSIONS_OFF: "новые входы выключены для всей платформы",
  EXTERNAL_CLOSE_RECONCILED_QUARANTINE_RETAINED: "закрыт вне бота, монета на карантине",
  MODERN_TERMINAL_QUARANTINE_RETAINED: "цикл завершён, монета на карантине",
  RISK_REFUSED: "отклонён проверкой риска",
  UNATTRIBUTED_EXPOSURE: "позиция на бирже без цикла",
};

export function reasonText(code: string): string {
  return REASON[code] ?? code;
}

/** What each system finding means, in the reader's words. */
const FINDING: Readonly<Record<string, string>> = {
  EXPOSURE_ACCOUNT_BLOCKED: "Новые входы закрыты для всего счёта",
  EXPOSURE_SLOT_BLOCKED: "Новые входы закрыты для отдельных слотов",
  OUTBOX_BEHIND: "Очередь уведомлений отстаёт — сообщения уже теряются",
  OUTBOX_DEAD_LETTERS: "Есть недоставленные уведомления",
  RECONCILIATION_STALE: "Сверка с биржей перестала продвигаться",
  RECONCILIATION_INCOMPLETE: "Есть циклы с незавершённой сверкой",
  RECONCILIATION_NEVER_RAN: "Сверка с биржей ни разу не проходила",
};

export function findingText(code: string): string {
  return FINDING[code] ?? code;
}

/** How a cycle ended, in words. */
const EXIT: Readonly<Record<string, string>> = {
  TRAILING: "трейлинг",
  TARGET: "цель",
  EMERGENCY: "аварийный выход",
  EMERGENCY_CLOSED: "аварийный выход",
  MANUAL: "вручную",
  BOT_AUTHORIZED_CLOSE: "закрыт ботом",
  BOT_CLOSE: "закрыт ботом",
  EXTERNAL_CLOSE: "закрыт вне бота",
  EXTERNAL_OR_MANUAL_CLOSE: "закрыт вне бота",
  delisting: "делистинг",
};

export function exitText(code: string): string {
  return EXIT[code] ?? code;
}
